/**
 * Design tokens for the redesigned admin screens (MCG design system).
 */
export const colors = {
  ink: '#0B1B2B',
  navy: '#002E47',
  slate: '#454F5B',
  muted: '#637381',
  subtle: '#919EAB',
  disabled: '#CBD0D7',
  border: '#E5E7EB',
  borderSoft: 'rgba(145,158,171,.32)',
  surface: '#FFFFFF',
  hover: '#F4F6F8',
  chip: '#F1F3F5',
  primary: '#015FFB',
  primaryDark: '#0151D5',
  primaryLighter: '#B3CFFE',
  primarySoft: '#E9F1FF',
  success: '#29D25D',
  successDark: '#1D9341',
  successSoft: '#BFF1CE',
  warningDark: '#B06E01',
  error: '#ED4245',
}

export const fonts = {
  ui: "'Inter', system-ui, sans-serif",
  display: "'Plus Jakarta Sans', 'Inter', system-ui, sans-serif",
}

export const shadows = {
  button: '0 2px 4px rgba(145,158,171,.32)',
  card: '0 12px 24px -4px rgba(145,158,171,.12), 0 0 2px rgba(145,158,171,.2)',
  popup: '0 20px 40px -4px rgba(145,158,171,.24), 0 0 2px rgba(145,158,171,.2)',
}

export const STATUS_STYLES = {
  Published: { color: colors.successDark, background: colors.successSoft },
  // Opaque (the design's rgba(145,158,171,.18) on white), so the pill stays
  // readable on top of course covers.
  Draft: { color: colors.muted, background: '#EBEEF0' },
}

// Tabler chevron-down in colors.muted, for native selects.
const SELECT_CHEVRON =
  "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23637381' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\")"

/**
 * A native <select> with the browser arrow swapped for a chevron set in from
 * the right edge, like the app's other dropdowns.
 */
export const nativeSelect = {
  appearance: 'none',
  WebkitAppearance: 'none',
  MozAppearance: 'none',
  paddingRight: 36,
  backgroundImage: SELECT_CHEVRON,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 12px center',
  backgroundSize: '16px 16px',
}

export const buttonReset = {
  padding: 0,
  border: 0,
  background: 'transparent',
  cursor: 'pointer',
  fontFamily: 'inherit',
  textAlign: 'left',
}
